export const colors = {
    primary: {
        main: '#0A1929', // Darker blue to match logo background
        light: '#1A2939',
        dark: '#060919',
    },
    secondary: {
        main: '#D4AF37', // Gold color from the logo
        light: '#E4BF47',
        dark: '#C49F27',
    },
    background: {
        default: '#FFFFFF',
        paper: '#F5F5F5',
    },
    text: {
        primary: '#333333',
        secondary: '#666666',
    }
};
